import { OrbitalSystem } from '../../../components/ui/orbital-system';

export default function RightConstellation() {
  return (
    <div className="relative">
      <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-[#DDE8E1] via-transparent to-[#E0DFF0] opacity-50" />
      <div
        className="relative rounded-[1.75rem] border border-stone-200/80 overflow-hidden shadow-[0_30px_80px_rgba(28,48,39,0.12)]"
        style={{ background: 'linear-gradient(165deg, #1a3328 0%, #142a20 40%, #0f2018 100%)' }}
      >
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
          <span className="text-[12rem] font-extralight text-white/[0.06] tracking-tighter leading-none" style={{ fontFamily: 'Outfit' }}>360</span>
        </div>
        <div className="h-[430px] relative">
          <OrbitalSystem className="absolute inset-0" />
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0f2018]/90 to-transparent p-5 pt-12 text-white">
          <p className="text-[10px] uppercase tracking-[0.16em] text-white/50">Live Module Map</p>
          <p className="mt-1.5 text-base font-medium text-white/90" style={{ fontFamily: 'Outfit' }}>10 modules orbiting one operating layer</p>
        </div>
      </div>
    </div>
  );
}
